import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";
import { canViewStandardsReview } from "../utils/appRoles";
import { getDecodedToken } from "../utils/jwtUtils";

export function useCanViewStandardsReview(): boolean {
  const { user } = useAuth();

  return useMemo(() => {
    const fromUser = user?.roles;
    if (fromUser?.length) {
      return canViewStandardsReview(fromUser);
    }
    const decoded = getDecodedToken();
    return canViewStandardsReview(decoded?.roles);
  }, [user?.roles]);
}
